import React, { useEffect, useRef } from 'react'
import * as AC from 'adaptivecards'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import createAdaptiveCardHostConfig from '../../utils/createAdaptiveCardHostConfig'

interface AdaptiveCardAttachmentProps {
  content: any
  height?: number
}

const adaptiveCard = new AC.AdaptiveCard()

const AdaptiveCardAttachment = ({ content, height }: AdaptiveCardAttachmentProps): JSX.Element => {
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)
  const divRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const customAdaptiveCardHostConfig = createAdaptiveCardHostConfig(themeColors.primary, themeColors.card.frame.background)
    adaptiveCard.hostConfig = new AC.HostConfig(customAdaptiveCardHostConfig)
  }, [themeColors])

  useEffect(() => {
    const clonedContent = structuredClone(content)
    clonedContent.minHeight = height ? `${height}px` : '0px'
    clonedContent.verticalContentAlignment = 'Center'

    adaptiveCard.parse(clonedContent)
    const htmlValue = adaptiveCard.render()

    if (divRef.current) {
      divRef.current.firstChild?.remove()
      htmlValue && divRef.current.appendChild(htmlValue)
    }
  }, [content, height])

  return <div ref={divRef} />
}

export default AdaptiveCardAttachment
